import { createStore, applyMiddleware } from "redux";
import { createLogger } from "redux-logger";
import rootReducer from "../modules/reducers/index";

const reduxLogger = createLogger();
export const store = createStore(rootReducer, applyMiddleware(reduxLogger));